import styled from '@emotion/styled';
import { css } from '@emotion/react/macro';

const HEADER_HEIGHT = '40px';
export const Header = styled.div`
  height: ${({ isFixedHeight }) => (isFixedHeight ? HEADER_HEIGHT : 'auto')};
  line-height: ${HEADER_HEIGHT};
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  padding: 0 10px;
`;

export const Title = styled.div`
  flex: 1;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  box-shadow: none;
  font-size: 20px;
  font-weight: 500;
  padding: 0 10px;
`;

export const ManagePanelIconPlaceholder = styled.div`
  width: 54px;
`;

const getWidthBasedOnIcons = ({ iconsCount }) => {
  const style = {};
  if ((iconsCount ?? 0) > 1) {
    style.width = `${iconsCount * 33}px`;
  }
  return css(style);
};

export const ManagePanelIcon = styled.div`
  display: flex;
  cursor: pointer;
  line-height: initial;
  height: 16px;
  &:hover {
    opacity: 0.8;
  }
  > svg {
    // color: #172b4d;
    // fill: #172b4d;

    color: ${({ theme }) => theme.colors.primary};
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const ManagePanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${getWidthBasedOnIcons};
`;
